import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {
  Modal,
  Typography,
  Icon,
  Card,
  Button,
  CircularLoader,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import "./../../scss/admin/components/_integrationsdashboard.scss";
import { getContentWrapperClass } from "../../utils/header";
// import  { Modal }   from 'react-bootstrap';
import config from "config";
import StyledChip from "../../components/styled/Chip";
import {
  defaultEmailTemplates,
  templateCategories,
} from "../../services/defaultTemplatesService";
import TemplateImageBox from "../../components/Cards/TemplateImageBox";
import NewEmailPreview from "../../components/NewEmailPreviewTemplate";
import Categories from "./Categories";
import ImageContentLoader from "../../components/ContentLoader/ImageContentLoader";
import theme from "../../theme";

const StyledBorderChip = styled(StyledChip).attrs()`
  height: 24px;
  width: 100%;
  justify-content: center;

  border: 1px solid ${(props) => props.theme.palette["primary"].c100};
`;

const ExploreAllBox = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  border-radius: 4px;
  height: 44px;
`;

const BottomBorderDiv = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const SelectedBackgroundDiv = styled.div`
  background-color: ${(props) =>
    props.selected && props.theme.palette.light.c200};
  border-radius: 4px;
`;

const StyledCateogriesCard = styled(Card).attrs()`
  width: 375px !important;
  height: calc(100vh-85px);
`;

const StyledTemplateList = styled("div").attrs()`
  padding: 24px 24px 0px;
  width: 375.5px;
  height: calc(100vh - 85px);
  overflow: scroll;
`;

const StyledW231Div = styled("div").attrs()`
  width: 218px;
  backroundcolor: ${(props) =>
    props.isSelectedImage ? theme.palette.common.white : ""}};
  box-shadow: ${(props) =>
    props.isSelectedImage ? "0px 0px 4px 0px rgba(56, 42, 106, 0.16)" : ":"};
`;

const StyledW180Div = styled("div").attrs()`
  width: 108px;
  backroundcolor: ${theme.palette.common.white};
  box-shadow: ${(props) =>
    props.isSelectedImage ? "0px 0px 4px 0px rgba(56, 42, 106, 0.16)" : ":"};
`;

const formatCategories = (categoriesResp) => {
  const categories = {};
  categoriesResp?.templateCategories?.data?.map((item) => {
    if (!categories[item?.category_id]) {
      categories[item?.category_id] = {
        name: item?.category_name,
        subcategories: [],
      };
    }
    categories[item?.category_id]["subcategories"].push({
      id: item?.subcategory_id,
      name: item?.subcategory_name,
    });
  });
  return categories;
};

const TemplateList = ({
  templates,
  templatesLoading,
  selectedTemplate,
  setSelectedTemplate,
  isEdit,
}) => {
  return (
    <>
      {templatesLoading ? (
        <div className="w-100">
          <CircularLoader vertical center size="lg" />
          <ImageContentLoader
            boxes={!isEdit ? 10 : 1}
            height={!isEdit ? 115 : 120}
            width={!isEdit ? 231 : 201}
          />
          {isEdit &&
            [1, 2, 3].map(() => {
              return (
                <>
                  <ImageContentLoader
                    boxes={!isEdit ? 10 : 1}
                    height={!isEdit ? 115 : 120}
                    width={!isEdit ? 231 : 201}
                    className="mt-24"
                  />
                </>
              );
            })}
        </div>
      ) : (
        templates?.map((item, i) => {
          let cardClassName = "";
          return (
            <StyledW231Div
              key={i}
              className={` mb-16 ${!isEdit && "ml-24"} text-center`}
              onClick={isEdit ? () => setSelectedTemplate(item) : () => {}}
              isSelectedImage={selectedTemplate?.id == item.id || item.selected}
            >
              <TemplateImageBox
                classname={cardClassName + " emailTemplate"}
                emailTemplate
                voucherUrl={config.album_image_s3_url + item.img_path}
                isDelete={item.isDelete}
                company_id={item.company_id}
                imageId={item.album_image_id}
                // deleteCardImage={this.handleDelete}
                name={item.name || "default"}
                cardId={i}
                bgImageClass={"banner-card-img"}
                cardTextClass={
                  item.selected ? "card-text-selected mb-2" : "mb-2"
                }
                isSelectedImage={
                  selectedTemplate?.id == item.id || item.selected
                }
                setSelectedTemplate={() => setSelectedTemplate(item)}
                isEdit={isEdit}
                isEditListing={true}
              />
            </StyledW231Div>
          );
        }) || <div></div>
      )}
    </>
  );
};

const TemplateSlicedList = ({
  templates,
  selectedTemplate,
  setSelectedTemplate,
  setIsExploreAll,
  isEdit,
  useCase,
}) => {
  let slicedList = [];
  const sliceCount = useCase?.includes("campaign") ? 5 : 4;
  if (templates) {
    slicedList = templates.slice(0, sliceCount);
  }

  const templatesListBoxes = slicedList?.map((item, i) => {
    return (
      <>
        <StyledW180Div
          key={i}
          onClick={isEdit ? () => setSelectedTemplate(item) : () => {}}
          isSelectedImage={selectedTemplate?.id == item.id || item.selected}
          className="mr-4 text-center cursor-pointer"
        >
          <TemplateImageBox
            emailTemplate
            voucherUrl={config.album_image_s3_url + item.img_path}
            isDelete={item.isDelete}
            company_id={item.company_id}
            imageId={item.album_image_id}
            // deleteCardImage={this.handleDelete}
            name={item.name || "default"}
            cardId={i}
            bgImageClass={"banner-card-img"}
            cardTextClass={item.selected ? "card-text-selected mb-2" : "mb-2"}
            isSelectedImage={selectedTemplate?.id == item.id || item.selected}
            setSelectedTemplate={() => setSelectedTemplate(item)}
            isEdit={isEdit}
            isPreview={false}
          />
        </StyledW180Div>
      </>
    );
  });
  templatesListBoxes.push(
    <ExploreAllBox className="p-12 mt-5 ml-4 cursor-pointer">
      <Typography.LabelText
        onClick={() => {
          setIsExploreAll(true);
          !selectedTemplate && setSelectedTemplate(templates[0]);
        }}
      >
        Explore All
      </Typography.LabelText>
    </ExploreAllBox>
  );

  return templatesListBoxes;
};

const HeaderComponent = () => (
  <div className="d-flex justify-content-between">
    <div className="">
      <Typography.H2 color="dark" shade="c300">
        Email Templates
      </Typography.H2>
    </div>
    <div className="d-flex align-items-center">
      {/* <div className="pr-24">
        <Button disabled>Create Your Template</Button>
      </div> */}
    </div>
  </div>
);

const LeftNavigation = ({
  templates,
  categories,
  categoriesLoading,
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  className = "",
  templatesLoading,
}) => (
  <StyledCateogriesCard
    spaceAround={7}
    className={`d-flex flex-column p-24 mr-8 ${className}`}
  >
    <Typography.LabelText color="dark" shade="c200" className="mb-8">
      Categories
    </Typography.LabelText>

    <SelectedBackgroundDiv
      key={"default"}
      className={`p-8 d-flex flex-row 
justify-content-between align-items-center w-100 cursor-pointer`}
      onClick={() => {
        selectedCategory && setSelectedCategory(null);
        selectedSubcategory && setSelectedSubcategory(null);
      }}
      selected={!selectedCategory}
    >
      <Typography color="dark" shade="c300" component="div">
        All Templates
      </Typography>

      {selectedCategory && (
        <div>
          <Icon iconName="RightArrow" size={14} />
        </div>
      )}
    </SelectedBackgroundDiv>
    <Categories
      categories={categories}
      templates={templates}
      categoriesLoading={categoriesLoading}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      selectedSubcategory={selectedSubcategory}
      setSelectedSubcategory={setSelectedSubcategory}
      templatesLoading={templatesLoading}
    />
  </StyledCateogriesCard>
);

const MainContent = ({
  templates,
  setSelectedTemplate,
  categories,
  categoriesLoading,
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  isEdit,
  isExploreAll,
  setIsExploreAll,
  selectedTemplate,
  useCase,
  templatesLoading,
}) => {
  const mainContentClassName = !isEdit
    ? "d-flex flex-content-start flex-wrap w-100 h-100"
    : "d-flex flex-content-start w-100";
  return (
    <>
      {!isEdit && (
        <LeftNavigation
          templates={templates}
          categories={categories}
          categoriesLoading={categoriesLoading}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedSubcategory={selectedSubcategory}
          setSelectedSubcategory={setSelectedSubcategory}
          className="h-100"
          templatesLoading={templatesLoading}
        />
      )}
      <div
        className={mainContentClassName}
        // style={isEdit ? { height: "85px" } : {}}
      >
        {templatesLoading ? (
          <div className="ml-24">
            {!isEdit ? (
              <>
                {/* <ImageContentLoader boxes={4} height={115} width={180} /> */}
                <CircularLoader center vertical size="lg" />
              </>
            ) : (
              <ImageContentLoader boxes={4} height={90} width={108} />
            )}
          </div>
        ) : !isEdit ? (
          <TemplateList
            templates={templates}
            setSelectedTemplate={setSelectedTemplate}
            templatesLoading={templatesLoading}
          />
        ) : (
          <TemplateSlicedList
            selectedTemplate={selectedTemplate}
            templates={templates}
            setSelectedTemplate={setSelectedTemplate}
            categories={categories}
            categoriesLoading={categoriesLoading}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSubcategory={selectedSubcategory}
            setSelectedSubcategory={setSelectedSubcategory}
            isEdit={true}
            isPreview={false}
            isExploreAll={isExploreAll}
            setIsExploreAll={setIsExploreAll}
            useCase={useCase}
          />
        )}
      </div>
    </>
  );
};

const MainContentModal = ({
  templates,
  setSelectedTemplate,
  categories,
  categoriesLoading,
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory,
  isExploreAll,
  setIsExploreAll,
  templatesLoading,
  selectedTemplate,
  accountReducer,
  useCase,
  selectedDate,
  denomination_val,
  validTill,
  currencyCode,
}) => {
  return (
    <>
      <Modal
        isOpen={isExploreAll || true}
        fullScreen={true}
        className="banner-modal p-0"
      >
        <BottomBorderDiv className="d-flex justify-content-between py-24 px-28">
          <div>
            <Typography.H2>Explore All Templates</Typography.H2>
            <Typography.BodySmall component="div">
              Choose email template in which the reward will be sent.
            </Typography.BodySmall>
          </div>
          <div>
            <Button onClick={() => setIsExploreAll(false)}>Done</Button>
          </div>
        </BottomBorderDiv>
        {/* {templatesLoading ? (
          <CircularLoader size="lg" vertical center />
        ) : ( */}
        <div className="d-flex">
          <LeftNavigation
            templates={templates}
            categories={categories}
            categoriesLoading={categoriesLoading}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSubcategory={selectedSubcategory}
            setSelectedSubcategory={setSelectedSubcategory}
            templatesLoading={templatesLoading}
          />
          <StyledTemplateList
            accountReducer={accountReducer}
            className="d-flex flex-content-start flex-wrap"
          >
            <TemplateList
              templates={templates}
              setSelectedTemplate={setSelectedTemplate}
              isEdit={true}
              selectedTemplate={selectedTemplate}
              templatesLoading={templatesLoading}
            />
          </StyledTemplateList>
          <StyledTemplateList className="w-100">
            <NewEmailPreview
              useCase={useCase || "code-campaign"}
              selectedTemplate={{
                ...selectedTemplate,
                image_id: selectedTemplate?.album_img_id,
              }}
              setSelectedTemplate={setSelectedTemplate}
              // updateState={this.updateState}
              // site_id={selected_site?.id ? selected_site.id : 0}
              company_primary_logo={selectedTemplate?.logo}
              showEditMessage={false}
              emailSubject={selectedTemplate?.subject}
              emailHeading={selectedTemplate?.message}
              showEgiftText={true}
              editColCampaign={true}
              buttonText={selectedTemplate?.redeem_button_text}
              validTill={validTill || "** Feb ***"}
              currencyCode={
                currencyCode ||
                (accountReducer?.userBalance &&
                  accountReducer?.userBalance?.currencyCode)
                  ? accountReducer?.userBalance?.currencyCode
                  : "INR"
              }
              isPreview={true}
              isEditDisabled={true}
              selectedDate={selectedDate}
              denomination_val={denomination_val}
              accountReducer={accountReducer}
            />
          </StyledTemplateList>
        </div>
        {/* )} */}
      </Modal>
    </>
  );
};

const Templates = (props) => {
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [templatesLoading, setTemplatesLoading] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [categories, setCategories] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [isExploreAll, setIsExploreAll] = useState(false);
  const isEdit = props.isEdit;
  useEffect(() => {
    (async () => {
      const emailTemplates = await defaultEmailTemplates();
      setTemplates(emailTemplates?.defaultEmailTemplates?.data || []);
      setTemplatesLoading(false);
    })();
  }, []);
  useEffect(() => {
    !props.selectedTemplate?.template_id && setSelectedTemplate(null);
  }, [props.selectedTemplate]);
  useEffect(() => {
    (async () => {
      const categoriesResp = await templateCategories();

      setCategories(formatCategories(categoriesResp) || []);
      setCategoriesLoading(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!selectedSubcategory) {
        setTemplatesLoading(true);
        setSelectedSubcategory(null);
        const emailTemplates = await defaultEmailTemplates({
          category_id: selectedCategory,
        });
        setTemplates(emailTemplates?.defaultEmailTemplates?.data || []);
        setTemplatesLoading(false);
      }
    })();
  }, [selectedCategory, selectedSubcategory]);

  useEffect(() => {
    (async () => {
      if (selectedSubcategory) {
        setTemplatesLoading(true);
        const emailTemplates = await defaultEmailTemplates({
          subcategory_id: selectedSubcategory,
        });
        setTemplates(emailTemplates?.defaultEmailTemplates?.data || []);
        setTemplatesLoading(false);
      }
    })();
  }, [selectedSubcategory]);
  useEffect(() => {
    selectedTemplate &&
      props.updateState &&
      props.updateState({
        company_primary_logo:
          config.album_image_s3_url + selectedTemplate?.img_path,

        emailLogo: selectedTemplate?.logo,
        selectedTemplate: {
          image_url: config.album_image_s3_url + selectedTemplate?.img_path,
          template_id: selectedTemplate?.id,
          id: selectedTemplate?.id,
          album_img_id: selectedTemplate?.album_img_id,
          image_id: selectedTemplate?.album_img_id,
        },
        showEditMessage: false,
        emailSubject: selectedTemplate?.subject,
        emailTitle: selectedTemplate?.heading,
        emailHeading: selectedTemplate?.message,
        showEgiftText: true,
        editColCampaign: true,
        buttonText: selectedTemplate?.redeem_button_text,
      });
  }, [selectedTemplate]);

  return (
    <div className="w-100 h-100">
      {/* {templatesLoading && !isExploreAll ? (
        <div style={{ minHeight: "120px" }}>
          <CircularLoader size="lg" vertical center />
        </div>
      ) : ( */}
      <div>
        {!isEdit && <HeaderComponent />}
        <div className="mt-16 d-flex">
          <MainContent
            categories={categories}
            templates={templates}
            categoriesLoading={categoriesLoading}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSubcategory={selectedSubcategory}
            setSelectedSubcategory={setSelectedSubcategory}
            setSelectedTemplate={setSelectedTemplate}
            isEdit={props?.isEdit}
            isExploreAll={isExploreAll}
            setIsExploreAll={setIsExploreAll}
            selectedTemplate={props.selectedTemplate}
            useCase={props.useCase}
            templatesLoading={templatesLoading}
          />
        </div>
        {isExploreAll && (
          <MainContentModal
            isExploreAll={isExploreAll}
            setIsExploreAll={setIsExploreAll}
            categories={categories}
            templates={templates}
            categoriesLoading={categoriesLoading}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSubcategory={selectedSubcategory}
            setSelectedSubcategory={setSelectedSubcategory}
            setSelectedTemplate={setSelectedTemplate}
            isEdit={isEdit}
            templatesLoading={templatesLoading}
            selectedTemplate={props.selectedTemplate}
            accountReducer={props.accountReducer}
            useCase={props.useCase}
            validTill={props.validTill}
            selectedDate={props.selectedDate}
            denomination_val={props.denomination_val}
            currencyCode={props.currencyCode}
          />
        )}

        <Modal
          isOpen={selectedTemplate && !isEdit}
          fullScreen={true}
          className="banner-modal p-0"
        >
          <BottomBorderDiv className="d-flex justify-content-between py-24 px-28">
            <div>
              <Typography.H2>{selectedTemplate?.name} Preview</Typography.H2>
            </div>
            <div>
              <Button onClick={() => setSelectedTemplate(null)}>Done</Button>
            </div>
          </BottomBorderDiv>
          {!isEdit && (
            <NewEmailPreview
              useCase={props.useCase || "code-campaign"}
              selectedTemplate={{
                ...selectedTemplate,
                image_id: selectedTemplate?.album_img_id,
              }}
              // updateState={this.updateState}
              // site_id={selected_site?.id ? selected_site.id : 0}
              company_primary_logo={selectedTemplate?.logo}
              showEditMessage={false}
              emailSubject={selectedTemplate?.subject}
              emailHeading={selectedTemplate?.message}
              showEgiftText={true}
              editColCampaign={true}
              buttonText={selectedTemplate?.redeem_button_text}
              validTill={props.validTill || "** Feb ****"}
              currencyCode={
                props.currencyCode ||
                (props.accountReducer?.userBalance &&
                  props.accountReducer?.userBalance?.currencyCode)
                  ? props.accountReducer?.userBalance?.currencyCode
                  : "INR"
              }
              isPreview={true}
              isEditDisabled={true}
              selectedDate={props.selectedDate}
              denomination_val={props.denomination_val}
              accountReducer={props.accountReducer}
            />
          )}
        </Modal>
      </div>
      {/* )} */}
    </div>
  );
};

export default withRouter(Templates);
